import './index.sass';

export default () => {
  const date = new Date();
  $('.js-date').html(date.getFullYear());
}